// import Video from '@/models/videos/video'
// import project from '@/store/account/project/moduleProject'

export default {
  isLoading: true,
  isUploading: false,
  categories: [],
  // category: new Category(),
}
